module.exports = __webpack_public_path__ + "static/uxpin_notepad_1-949378f638d84d1cd993b0ba564fc2f4.png";